import React from "react";

const About = () => {
  return (
    <div className="about-page" style={{ padding: "2rem" }}>
      <h1>About Us</h1>
      <p>
        <strong>Welcome to E-comm — Your Trusted Destination for the Latest in Electronics.</strong>
      </p>
      <p>
        At <strong>E-comm</strong>, we’re passionate about bringing you the best in technology at unbeatable prices. 
        From cutting-edge smartphones and smartwatches to powerful laptops, home gadgets, and accessories, 
        we aim to be your one-stop shop for all things electronic.
      </p>
      <p>
        We believe that shopping for electronics should be easy, reliable, and affordable. That’s why we've created a smooth, 
        user-friendly online shopping experience that lets you browse, compare, and purchase products from the comfort of your home.
      </p>
      <h3>Why Choose E-comm?</h3>
      <ul>
        <li>Wide Selection of top-quality electronic products</li>
        <li>Secure & Simple Checkout process</li>
        <li>Fast Delivery and reliable service</li>
        <li>Customer-Centric Support — we’re always here to help</li>
        <li>Affordable Prices without compromising on quality</li>
      </ul>
      <p>
        Whether you're a tech enthusiast or simply looking for a great deal, <strong>E-comm</strong> is here to power your digital lifestyle.
      </p>
    </div>
  );
};

export default About;
